// Core
import React, { useState } from "react";
import Switch from "react-switch";

// Styles
import "./styles.scss";

const CustomSwitch = ({
  checked,
  onChange,
  disabled,
  onColor,
  offColor,
  label,
}) => {
  const [isChecked, setIsChecked] = useState(checked || false);
  const handleChange = (nextChecked) => {
    if (onChange) {
      onChange(nextChecked);
    } else {
      setIsChecked(nextChecked);
    }
  };

  return (
    <div className="d-flex align-items-center">
      <Switch
        onChange={handleChange}
        checked={onChange ? checked : isChecked}
        disabled={disabled || false}
        onColor={onColor || "#E2E2E2"}
        offColor={offColor || "#E2E2E2"}
        uncheckedIcon={false}
        checkedIcon={false}
        height={20}
        width={40}
        handleDiameter={24}
        className="custom-switch"
      />
      <span className="switch-label ms-3">{label}</span>
    </div>
  );
};

export default CustomSwitch;
